module.exports = __webpack_public_path__ + "img/436.1fffa660.jpg";